<template>
  <div></div>
</template>

<script>
export default {
  name: "LogOut",

  created() {
    window.onbeforeunload = null
    this.api_signOut()
  }
}
</script>

<style scoped>

</style>